module.exports = __webpack_public_path__ + "cwj.png?2dc7e4c1734b1cbe1ddeeac864684de2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cwj.png
// module id = 143
// module chunks = 0